import * as React from 'react';
import { useWillUnMountEffect } from '.';
/**
 * set up a timeout which is cleared automatically when the component unmounts
 * @param time the time to pass before the callback is fired
 * @param callback the callback to run after the given time
 */
export function useTimeout(callback, time) {
    const timeout = React.useRef();
    const [waiting, setWaiting] = React.useState(false);
    const resolvePromise = React.useRef();
    const clear = React.useCallback(() => {
        var _a;
        clearTimeout(timeout.current);
        (_a = resolvePromise.current) === null || _a === void 0 ? void 0 : _a.call(resolvePromise, undefined);
        resolvePromise.current = undefined;
    }, []);
    const set = React.useCallback((overrideCallback, overrideTime) => {
        clear();
        return new Promise((resolve) => {
            setWaiting(true);
            resolvePromise.current = resolve;
            timeout.current = setTimeout(() => {
                var _a;
                setWaiting(false);
                const value = (_a = (overrideCallback !== null && overrideCallback !== void 0 ? overrideCallback : callback)) === null || _a === void 0 ? void 0 : _a();
                resolve(value);
            }, overrideTime !== null && overrideTime !== void 0 ? overrideTime : time);
        });
    }, [time, callback]);
    useWillUnMountEffect(clear);
    return { set, clear, waiting };
}
